import classNames from 'classnames/bind';
import styles from './CancelMembership.module.css';
import Delete from '../Account/Delete';
import { useGetMembershipCancelQuery } from '../../../services/membership';

export default function CancelMembership() {
  const cx = classNames.bind(styles);

  const { data, isLoading } = useGetMembershipCancelQuery();

  if (isLoading || !data) return null;

  return <Delete data={data} />;
}
